/**
 * 時間表示フォントのオプション定義
 */
export type TimeDisplayFont =
    | 'normal'
    | 'digital-7'
    | 'digital-7-dark'
    | 'digital-7-max'
    | 'digital-7-max-dark';

export interface FontOption {
    value: TimeDisplayFont;
    label: string;
    fontFamily: string;
    isDark?: boolean;
}

/**
 * 時間表示フォントのオプション
 */
export const FONT_OPTIONS: FontOption[] = [
    {
        value: 'normal',
        label: '標準',
        fontFamily: '', // コトミルの標準フォント（bodyで設定されているフォント）を使用
    },
    {
        value: 'digital-7',
        label: 'デジタル',
        fontFamily: 'Digital-7, sans-serif',
    },
    {
        value: 'digital-7-dark',
        label: 'デジタル（ダーク）',
        fontFamily: 'Digital-7, sans-serif',
        isDark: true,
    },
    {
        value: 'digital-7-max',
        label: 'デジタルMAX',
        fontFamily: 'Digital-7, sans-serif',
    },
    {
        value: 'digital-7-max-dark',
        label: 'デジタルMAX（ダーク）',
        fontFamily: 'Digital-7, sans-serif',
        isDark: true,
    },
];

export const DEFAULT_FONT: TimeDisplayFont = 'normal';

export function getFontOption(value: TimeDisplayFont): FontOption {
    return FONT_OPTIONS.find((opt) => opt.value === value) || FONT_OPTIONS[0];
}
